import { createContext } from 'react';

const ReviewRequestContext = createContext();

export default ReviewRequestContext;
